import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  IconButton,
  TableHead,
} from '@mui/material';
import { ICopperPipingRequest } from '../../../utils/entities/interface';
import { capitalizeWords, formatDateAndTime } from '../../../utils/helper';
import { ListTable } from '../../molecules/ListTable';
import { SkeletonRows } from '../../skeletons/list';

export const CopperPipingRequests = ({
  requests,
  isLoading,
  onUpdate,
  tableCell,
}: {
  requests: any[];
  isLoading: boolean;
  onUpdate: () => void;
  tableCell?: any[];
}) => {
  return (
    <>
      <ListTable
        headerCells={tableCell?.map((cell) => cell) || []}
        rows={requests}
        isLoading={isLoading}
        renderCell={(request: ICopperPipingRequest, colIndex: number) => {
          switch (colIndex) {
            case 0:
              return request?.enquiryId || '-';

            case 1:
              return capitalizeWords(request?.user?.name) || 'N/A';

            case 2:
              return `+91-${request?.user?.phoneNumber?.slice(0, 10)}`;

            case 3:
              return request?.schedule?.slot?.replaceAll('_', ' ') || 'N/A';

            case 4:
              return formatDateAndTime(request?.schedule?.date) || 'N/A';

            case 5:
              return capitalizeWords(request?.status) || 'N/A';

            case 6:
              return formatDateAndTime(request?.updatedAt) || 'N/A';

            default:
              return null;
          }
        }}
      />
    </>
  );
};
